import { MenuItem } from '../../menuitem';

/**
 * Filters the menu items to return only the visible ones.
 * If no visible menu items are found, it returns a menu with a label 'No Option Available'.
 *
 * @param menuItems - The array of menu items to filter.
 * @param noOptionLabel - The label of menu to be shown when no available option. The value is from locale configuration each project.
 *
 * @returns - The array of visible menu items or an array with a single menu item with label 'No Option Available'.
 */
const filterVisibleMenu = (
  menuItems: MenuItem[],
  noOptionLabel?: string,
): MenuItem[] => {
  const emptyMenu: MenuItem = {
    label: noOptionLabel,
    disabled: true,
  };

  const visibleMenu = menuItems.filter((menu) => menu.visible !== false);

  return visibleMenu.length ? visibleMenu : [emptyMenu];
};

export default filterVisibleMenu;
